import React, { useEffect, useState } from "react";
import { boardFetch, isDemoData } from "../boardData";
import DemoRadarMap from "../demo/DemoRadarMap";
import { useCoordinates } from "./common";

// Embedded radar (RainViewer) plus active NWS alerts for the board's location.
const WeatherRadarWidget = ({ config = {}, agency, board }) => {
  const { lat, lng } = useCoordinates(agency, board);
  const [alerts, setAlerts] = useState([]);
  const zoom = config.zoom || 7;

  useEffect(() => {
    if (config.showAlerts === false || lat == null || lng == null) return undefined;
    let cancelled = false;
    const load = async () => {
      try {
        const res = await boardFetch(`https://api.weather.gov/alerts/active?point=${lat},${lng}`, {
          headers: { Accept: "application/geo+json" },
        });
        const json = await res.json();
        if (!cancelled) setAlerts((json.features || []).map((f) => f.properties));
      } catch (err) {
        console.warn("weather alerts failed", err);
      }
    };
    load();
    const t = setInterval(load, 10 * 60 * 1000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [lat, lng, config.showAlerts]);

  if (lat == null || lng == null) {
    return (
      <div className="sb-card sb-radar">
        <div className="sb-card-title">Weather Radar</div>
        <div className="sb-empty"><div>Set this board's location to show radar.</div></div>
      </div>
    );
  }

  const radarUrl =
    `https://www.rainviewer.com/map.html?loc=${lat},${lng},${zoom}` +
    `&oFa=0&oC=0&oU=0&oCS=1&oF=0&oAP=1&c=3&o=83&lm=1&layer=radar&sm=1&sn=1`;

  return (
    <div className="sb-card sb-radar">
      <div className="sb-radar-frame">
        {isDemoData() ? (
          <DemoRadarMap lat={lat} lng={lng} zoom={zoom} />
        ) : (
          <iframe title="Weather radar" src={radarUrl} frameBorder="0" allowFullScreen />
        )}
      </div>
      {alerts.length > 0 && (
        <div className="sb-radar-alerts">
          {alerts.slice(0, 3).map((a, i) => (
            <div className="sb-radar-alert" key={i}>
              <span className="sb-radar-alert-event">{a.event}</span>
              <span className="sb-radar-alert-area">{a.areaDesc}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WeatherRadarWidget;
